import React, { useEffect, useState } from "react";
import Sidebar from "../../Common/Sidebar";
import EmployerLayout from "./Common/EmployerLayout";
import { FiEdit, FiLock } from "react-icons/fi";
import { FaUser, FaBuilding, FaEnvelope, FaPhone, FaGlobe, FaFileInvoice } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { GetUser, UpdateUser } from "../../../Redux/Slices/User";
import { useNavigate } from "react-router-dom";
import hidePwdImg from '../../../asset/new/icons/hide_passwd_icon.svg';
import showPwdImg from '../../../asset/new/icons/show_passwd.svg';
import "../../../asset/new/css/employer-modern.css";


const EmployerProfile = () => {
  const { userData } = useSelector((state) => state?.User);
  const [isRevealPwd, setIsRevealPwd] = useState(false);
  const [isRevealPwd2, setIsRevealPwd2] = useState(false);
  const [newPass, setNewPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let id = localStorage.getItem("id");

  //Password Reset Handle
  const handlePasswordReset = async (e) => {
    e.preventDefault();
    let id = localStorage.getItem("id");
    if (newPass === confirmPass) {
      let newPassword = { password: newPass };
      await UpdateUser(id, newPassword);
      setError("");
    } else {
      setError("Password doesn't match");
    }
  };
  useEffect(() => {
    dispatch(GetUser(id));
    document.title = "Profile | CAJobPortal";
  }, []);
  return (
    <div className="employer-layout">
      <Sidebar />
      <EmployerLayout breadcrumbs={['Employer', 'Profile']}>
        <div className="employer-page-header">
          <h1 className="employer-page-title">My Profile</h1>
        </div>

        <div className="employer-form-row" style={{ gridTemplateColumns: '1fr 1fr' }}>
          {/* Contact Information Card */}
          <div className="employer-card">
            <div className="employer-card-header">
              <h3 className="employer-card-title">Contact Information</h3>
            </div>
            <div className="employer-card-body">
              <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                <div className="employer-flex employer-items-center employer-gap-2">
                  <FaUser style={{ color: 'var(--employer-primary)' }} />
                  <div>
                    <div style={{ fontSize: '0.75rem', color: 'var(--employer-text-muted)' }}>Name</div>
                    <div style={{ fontWeight: 500 }}>{userData?.name || 'N/A'}</div>
                  </div>
                </div>
                <div className="employer-flex employer-items-center employer-gap-2">
                  <FaBuilding style={{ color: 'var(--employer-primary)' }} />
                  <div>
                    <div style={{ fontSize: '0.75rem', color: 'var(--employer-text-muted)' }}>Designation</div>
                    <div style={{ fontWeight: 500 }}>{userData?.experience[0]?.designation || 'N/A'}</div>
                  </div>
                </div>
                <div className="employer-flex employer-items-center employer-gap-2">
                  <FaBuilding style={{ color: 'var(--employer-primary)' }} />
                  <div>
                    <div style={{ fontSize: '0.75rem', color: 'var(--employer-text-muted)' }}>Company Name</div>
                    <div style={{ fontWeight: 500 }}>{userData?.experience[0]?.company_name || 'N/A'}</div>
                  </div>
                </div>
                <div className="employer-flex employer-items-center employer-gap-2">
                  <FaGlobe style={{ color: 'var(--employer-primary)' }} />
                  <div>
                    <div style={{ fontSize: '0.75rem', color: 'var(--employer-text-muted)' }}>Company Website</div>
                    <div style={{ fontWeight: 500 }}>{userData?.experience[0]?.company_web || 'N/A'}</div>
                  </div>
                </div>
                <div className="employer-flex employer-items-center employer-gap-2">
                  <FaEnvelope style={{ color: 'var(--employer-primary)' }} />
                  <div>
                    <div style={{ fontSize: '0.75rem', color: 'var(--employer-text-muted)' }}>Email</div>
                    <div style={{ fontWeight: 500 }}>{userData?.email || 'N/A'}</div>
                  </div>
                </div>
                <div className="employer-flex employer-items-center employer-gap-2">
                  <FaPhone style={{ color: 'var(--employer-primary)' }} />
                  <div>
                    <div style={{ fontSize: '0.75rem', color: 'var(--employer-text-muted)' }}>Phone</div>
                    <div style={{ fontWeight: 500 }}>{userData?.mobile || 'N/A'}</div>
                  </div>
                </div>
                <div className="employer-flex employer-items-center employer-gap-2">
                  <FaFileInvoice style={{ color: 'var(--employer-primary)' }} />
                  <div>
                    <div style={{ fontSize: '0.75rem', color: 'var(--employer-text-muted)' }}>GST No</div>
                    <div style={{ fontWeight: 500 }}>{userData?.gst || 'N/A'}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="employer-card-footer">
              <button
                onClick={() => navigate("/employer/edit/profile")}
                className="employer-btn employer-btn-primary"
              >
                <FiEdit /> Edit Profile
              </button>
            </div>
          </div>
          {/* Change Password Card */}
          <div className="employer-card">
            <div className="employer-card-header">
              <h3 className="employer-card-title">Change Password</h3>
            </div>
            <div className="employer-card-body">
              {error && (
                <div className="employer-alert employer-alert-danger" style={{ marginBottom: '1rem' }}>
                  <div className="employer-alert-message">{error}</div>
                </div>
              )}
              <div className="employer-form-group">
                <label className="employer-form-label">New Password</label>
                <div style={{ position: 'relative' }}>
                  <input
                    onChange={(e) => setNewPass(e.target.value)}
                    type={isRevealPwd ? "text" : "password"}
                    className="employer-form-input"
                    placeholder="Enter new password"
                  />
                  <img
                    title={isRevealPwd ? "Hide password" : "Show password"}
                    alt="passwd_img"
                    src={isRevealPwd ? hidePwdImg : showPwdImg}
                    onClick={() => setIsRevealPwd(prevState => !prevState)}
                    style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', width: '20px' }}
                  />
                </div>
              </div>
              <div className="employer-form-group">
                <label className="employer-form-label">Confirm Password</label>
                <div style={{ position: 'relative' }}>
                  <input
                    onChange={(e) => setConfirmPass(e.target.value)}
                    type={isRevealPwd2 ? "text" : "password"}
                    className="employer-form-input"
                    placeholder="Confirm new password"
                  />
                  <img
                    title={isRevealPwd2 ? "Hide password" : "Show password"}
                    alt="passwd_img"
                    src={isRevealPwd2 ? hidePwdImg : showPwdImg}
                    onClick={() => setIsRevealPwd2(prevState => !prevState)}
                    style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', width: '20px' }}
                  />
                </div>
              </div>
            </div>
            <div className="employer-card-footer">
              <button
                onClick={handlePasswordReset}
                className="employer-btn employer-btn-primary"
              >
                <FiLock /> Change Password
              </button>
            </div>
          </div>
        </div>
      </EmployerLayout>
    </div>
  );
};

export default EmployerProfile;
